/**
 * This is the main entry point for the browserify bundle and handles
 * bootstrapping the clientside. Try to keep it small! :D
 */

/**
 * Dependencies
 */
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import initBaseStyles from '@nerdwallet/base-styles/init';
import { initBrowserEvents } from '@nerdwallet/analytics';

// Route Definitions
import routes from './routes/index';

// Webpack lets us us embed styles and assets within the code.
require('@nerdwallet/base-styles/reset.css');
require('@nerdwallet/base-styles/base.css');
require('./styles/main.less');

initBaseStyles();
initBrowserEvents();
if (typeof __SENTRY_VERSION__ !== 'undefined') {
  // Require this here so we don't see a handful of console warnings related to finding sourcemaps
  // eslint-disable-next-line global-require
  require('@nerdwallet/sentry').initSentryBrowser({
    version: __SENTRY_VERSION__,
  });
}
export default () => <Router>{routes}</Router>;
